import BottomSheet from '@/core/components/BottomSheet/BottomSheet';

export default BottomSheet;
